import type { BaseKeyFunction } from "../../../../lib";

export const keyQueueSkips: BaseKeyFunction = () => ["queue-skips"];
